export default "__VITE_ASSET__cLNnT28H__"